module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tableSize flipTable"
  }, [_c('tr', _vm._l((_vm.header), function(head, n) {
    return _c('th', {
      key: n,
      staticClass: "tableHeader"
    }, [_vm._v("\n      " + _vm._s(head) + "\n    ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.viewData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "sortCenter"
    }, [_vm._v("\n        " + _vm._s(data.creative_kr_nm ? data.creative_kr_nm : data.group_nm) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "sortCenter"
    }, [_vm._v("\n        " + _vm._s(data.ad_knd_nm) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.imp_cnt)) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.click_cnt)) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(isNaN(data.ctr) ? 0 : data.ctr.toFixed(1)) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "sortRight",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.sum_budget_amt)) + "\n        ")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd02b07","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creativeGroup/CgTable.vue
// module id = 843
// module chunks = 1